module.exports = __webpack_public_path__ + "img/Revenue.900da79d.svg";